export default __webpack_public_path__ + "static/media/CU.f729f1fa.svg";